<template>
  <div class="layout">
    <HeaderAppDesktop />

    <!-- Page content -->
    <slot> </slot>

    <HeaderAppMobile v-if="!hideMobileMenu" />
    <Footer v-else />

    <UpgradePromptModal v-if="showUpgradePromptModal" />
  </div>
</template>

<script setup lang="ts">
import Footer from '@/app/components/Footer.vue'
import HeaderAppDesktop from '@/app/components/header/AppDesktop.vue'
import HeaderAppMobile from '@/app/components/header/AppMobile.vue'
import UpgradePromptModal from '@/app/components/UpgradePromptModal.vue'

withDefaults(
  defineProps<{
    /**
     * Remove the header mobile menu (HeaderAppMobile)
     */
    hideMobileMenu?: boolean
    /**
     * Control rendering of the upgrade prompt modal for transient layouts.
     */
    showUpgradePromptModal?: boolean
  }>(),
  {
    showUpgradePromptModal: true,
  },
)
</script>
